/* Communities featured homes */
import 'slick-carousel';

export function communities_featured_homes_slider() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--communities-featured-homes-slider' ).length <= 0 ) {
				return;
			}

			$( '.block--communities-featured-homes-slider' ).each( ( i, e ) => {
				const slider = $( e ).find( '.cards' );

				slider.slick( {
					infinite: false,
					slidesToShow: 2,
					slidesToScroll: 1,
					rows: 0,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								arrows: false,
								dots: true,
								slidesToShow: 1,
							}
						}
					]
				} );
			} );

			const hiddenizer = ( ev ) => {
				const hid		= $( '.block--communities-featured-homes-slider .hiddenizer' );
				const menu		= $( '#community-desktop-submenu' );

				if ( menu.length <= 0 ) {
					return;
				}

				const right_pad	= 50;
				const width		= parseInt( menu.offset().left + menu.innerWidth() + right_pad ); 

				if ( 'block' == hid.css( 'display' ) ) {
					hid.css( 'width', width );
				}
			};

			$( window ).on( 'resize', hiddenizer );
			$( document ).ready( hiddenizer );
		}

		init();

	} )( window.jQuery );
}